<template>
  <div class="contract-manage">
    <div class="searchArea">
      <el-form inline>
        <el-form-item style="margin-right: 25px">
          <el-input class="search-input" v-model.trim="contractName" style="width: 150px" clearable maxlength="50" placeholder="请输入合同名称"></el-input>
        </el-form-item>
        <el-form-item style="margin-right: 25px">
          <el-input class="search-input" v-model.trim="customerName" style="width: 150px" clearable maxlength="50" placeholder="请输入客户名称"></el-input>
        </el-form-item>

        <el-form-item style="margin-right: 25px">
          <el-select placeholder="请选择合同状态" v-model="contractState" style="width: 150px" clearable>
            <el-option v-for="(val, key) in stateOptions" :key="key" :label="val" :value="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            style="width: 300px"
            v-model="dateRange"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            range-separator="至"
            :start-placeholder="`合同开始日期`"
            :end-placeholder="`合同结束日期`"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button plain @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <div>
        <auth-button code="HTXZ" type="primary" @click="addCust">新建合同</auth-button>
      </div>
    </div>

    <el-form inline class="mb-15">
      <auth-button code="HTSC" type="danger" plain @click="otherOperate('delete')" size="mini" class="el-icon-delete"> 删除 </auth-button>
    </el-form>

    <div class="list-table">
      <new-table ref="newTable" firstType="selection" :data="tableData" :columns="columns" :pages="pages"></new-table>
    </div>
  </div>
</template>

<script>
import NewTable from "@/components/new-table.vue";
import { AuditState, AuditStateVal } from "@/utils/enum";

export default {
  data() {
    return {
      contractName: "",
      customerName: "",
      contractState: "",
      dateRange: "",
      stateOptions: AuditState,
      tableData: [],
      columns: [
        {
          label: "合同名称",
          render: (h, { row }) => (
            <el-button type="text" onClick={() => this.$router.push(`./contract-detail?id=${row.id}`)}>
              {row.contractName}
            </el-button>
          ),
        },
        { label: "合同编号", prop: "contractNo", minWidth: "150px" },
        {
          label: "客户名称",
          render: (h, { row }) => (
            <el-button type="text" onClick={() => this.$router.push(`./customer-detail?id=${row.customerId}`)}>
              {row.customerName}
            </el-button>
          ),
        },
        { label: "合同金额", prop: "contractAmount" },
        { label: "联系人", prop: "linkName" },
        { label: "手机", prop: "linkPhone" },
        { label: "创建时间", render: (h, { row }) => row.creationTime && row.creationTime.slice(0, 10) },
        { label: "开始时间", render: (h, { row }) => row.startDate && row.startDate.slice(0, 10) },
        { label: "结束时间", render: (h, { row }) => row.endDate && row.endDate.slice(0, 10) },
        { label: "签订时间", render: (h, { row }) => row.signDate && row.signDate.slice(0, 10) },
        { label: "回款金额", prop: "collectionAmount" },
        { label: "合同状态", prop: "auditState", render: (h, { row }) => <audit-state-text state={row.state} /> },
        {
          label: "操作",
          width: "120px",
          render: (h, { row }) => (
            <span>
              <el-button type="text" onClick={() => this.$router.push(`/contract-detail?id=${row.id}`)}>
                查看
              </el-button>
              {row.state === 2 ? (
                <auth-button code="HTXG" type="text" onclick={() => this.editDetail(row.id)}>
                  编辑
                </auth-button>
              ) : (
                ""
              )}
              {!row.state ? (
                <auth-button type="text" code="HTSP" style="color: #ffc107" onClick={() => this.contractCheck(row)}>
                  处理
                </auth-button>
              ) : (
                ""
              )}
            </span>
          ),
        },
      ],
      pages: {
        props: {
          "page-size": 20,
          "current-page": 1,
          total: 0,
        },
        on: {
          "current-change": (p) => {
            this.currentChange(p);
          },
          "size-change": this.sizeChange,
        },
      },
      onlyUseOnce: false,
    };
  },
  mounted() {
    this.judge();
  },
  methods: {
    async judge() {
      switch (this.$route.params.status) {
        case "待审核合同":
          this.contractState = "0";
          await this.getData();
          break;

        case "待审核回款":
          break;

        case "即将到期合同":
          this.onlyUseOnce = true;
          await this.getData();
          this.onlyUseOnce = false;
          break;

        default:
          await this.getData();
          break;
      }
    },
    async getData() {
      this.$refs.newTable.clearSelection();
      const params = {
        contractName: this.contractName,
        customerName: this.customerName,
        startDt: (this.dateRange && this.dateRange[0]) || "",
        endDt: (this.dateRange && this.dateRange[1]) || "",
        state: this.contractState,
        pageIndex: this.pages.props["current-page"],
        pageSize: this.pages.props["page-size"],
        expireState: this.onlyUseOnce ? 1 : 0,
      };
      let url = `/Crm/Contract/ContractPageList`;
      await this.axios.get(url, { params }).then((res) => {
        this.tableData = res.data;
        this.pages.props.total = res.dataCount;
      });
    },
    addCust() {
      this.$router.push("/add-contract");
    },
    editDetail(id) {
      this.$router.push(`/add-contract?id=${id}`);
    },
    otherOperate(key) {
      let sel = this.$refs.newTable.$refs.table.selection;
      if (sel.length) {
        let listId = sel.map((s) => s.id);
        switch (key) {
          case "delete":
            this.delCustomers(sel);
            break;
          default:
            break;
        }
      } else {
        this.$message.warning(`请先选择合同！`);
      }
    },
    delCustomers(list) {
      const cont = list.find((item) => item.state !== AuditStateVal.withdraw);
      if (cont) return this.$message.warning(`“${cont.contractName}” 合同当前状态是${AuditState[cont.state]}，不能删除`);
      this.$confirm("确定删除所选合同吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios
          .post(`/Crm/Contract/DelContractByIds`, {
            ids: list.map((s) => s.id),
          })
          .then(() => {
            this.$message.success(`删除成功！`);
            this.onSearch();
          });
      });
    },
    onSearch() {
      this.currentChange(1);
    },
    reset() {
      this.contractName = "";
      this.customerName = "";
      this.contractState = "";
      this.dateRange = [];
      this.onSearch();
    },
    sizeChange(size) {
      this.pages.props["page-size"] = size;
      this.currentChange(1);
    },
    currentChange(p) {
      this.pages.props["current-page"] = p;
      this.getData();
    },
    // 合同审批
    contractCheck(row) {
      this.$router.push(`/approval-info?insId=${row.insId}&dataId=${row.id}&type=contract`);
    },
  },
  components: {
    NewTable,
  },
};
</script>

<style scoped lang="scss">
.contract-manage {
  flex-direction: column;
  .searchArea {
    display: flex;
    justify-content: space-between;
    ::v-deep .el-form-item__label {
      padding-right: 5px;
    }
  }
}
</style>
